var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotkeysIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 0a7 7 0 0 0-7 7v34a7 7 0 0 0 7 7h34a7 7 0 0 0 7-7V7a7 7 0 0 0-7-7H7Zm1.4 4.2c-.2.2-.3.5-.3.8v24.7c0 .3.1.6.3.8.2.2.4.3.7.3h2.5c.2 0 .5 0 .7-.3.2-.2.3-.5.3-.8V19.4h13v10.3c0 .3.1.6.3.8.2.2.4.3.7.3h2.5c.2 0 .5-.1.7-.3.2-.2.3-.5.3-.8V5c0-.3-.1-.6-.3-.8A.9.9 0 0 0 29 4h-2.5a1 1 0 0 0-.7.3c-.2.2-.3.5-.3.8v10.5h-13V5c0-.3-.1-.6-.3-.8a.9.9 0 0 0-.7-.3H9a1 1 0 0 0-.7.3ZM59 0a7 7 0 0 0-7 7v34a7 7 0 0 0 7 7h34a7 7 0 0 0 7-7V7a7 7 0 0 0-7-7H59Zm3.4 8.3a2 2 0 0 0-2 2v27.4c0 1 1 2 2 2h27.3a2 2 0 0 0 2-2V10.3a2 2 0 0 0-2-2H62.4Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotkeysIcon);
export default __webpack_public_path__ + "static/media/hotkeys-icon.3e06e559338bcbb9607bd818af20bd3e.svg";
export { ForwardRef as ReactComponent };